<template>
  <div :style="divStyle">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Modal title="Title" v-model="showModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#ff9900;text-align:center">
        <span>输入设备编号</span>
      </p>
      <div style="text-align:center">
        <div>
          <Input style="margin-left:10px; width:200px;" v-model="deviceId" placeholder="请输入设备编号"></Input>
        </div>
      </div>
      <div slot="footer">
        <Button :loading="isLoading" type="warning" size="large" @click="inputDeviceId" long>确认</Button>
      </div>
    </Modal>
    <Tabs>
      <TabPane label="下发队列信息" name="list" icon="ios-list">
        <Row style="padding-bottom: 10px;">
          <Col span="4" style="padding-right: 10px;">
            <Button type="primary" long icon="ios-search" @click="showModal = true">检索</Button>
          </Col>
        </Row>
        <Table
          ref="selectionTable"
          :max-height="height"
          :data="showData"
          :columns="showColumns"
          stripe
          border
        >
          <template slot-scope="{ row, index }" slot="download">
            <Button type="primary" shape="circle" @click="showDetailed(row, index, $event)">参数列表</Button>
          </template>
          <template slot-scope="{ row, index }" slot="remove">
            <Button type="primary" shape="circle" @click="remove(row, index, $event)">移除指令</Button>
          </template>
        </Table>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  name: "manage_down_queue",
  computed: {
    divStyle() {
      var style = {};
      if (this.$parent.$refs.mainContent) {
        style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      } else {
        style.width = window.innerWidth - 279 + "px";
      }
      //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    }
  },

  mounted() {},
  data() {
    return {
      showModal: true,
      isLoading: false,
      deviceId: "",
      currentProfile: "",
      isSpinShow: false,
      height: window.innerHeight,
      showData: [],
      showColumns: [
        {
          title: "设备编号",
          key: "address"
        },
        {
          title: "存储编号",
          key: "primaryId"
        },
        {
          title: "时间戳",
          key: "timestamp"
        },
        {
          title: "服务编号",
          key: "serviceId"
        },
        {
          title: "方法名称",
          key: "method"
        },
        {
          title: "查看参数列表",
          slot: "download",
          align: "center"
        },
        {
          title: "移除指令",
          slot: "remove",
          align: "center"
        }
      ]
    };
  },
  methods: {
    inputDeviceId() {
      if (this.deviceId == "") {
        this.$Notice.info({
          title: "提示",
          desc: "请输入设备编号"
        });
      } else {
        this.showPage();
        this.showModal = false;
      }
    },
    showDetailed(row, index, event) {
      // 遍历数据集拼接HTML
      console.log;
      var htmlStr =
        "<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; '>";
      var amount = 0;
      Object.keys(row.paras).forEach(function(key) {
        if (amount % 2 == 0) {
          htmlStr += "<tr >";
        }
        htmlStr +=
          "<td style='margin-top:2px; border: 1px solid #C0C0C0;'>" +
          key +
          "</td><td style='margin-top:2px; border: 1px solid #C0C0C0;'>" +
          row.paras[key] +
          "</td>";
        if (amount % 2 == 1) {
          htmlStr += "</tr>";
        }
        amount++;
      });
      htmlStr += "</table>";

      this.selectDataHtml = htmlStr;
      this.selectData = row.data;
      // this.showDrawer = true;

      var that = this;
      this.$Notice.open({
        title: "数据域:<br/>" + row.data.toUpperCase(),
        // desc: htmlStr,
        render: h => {
          return h("div", {
            on: {},
            style: {
              height: "100%",
              width: "100%"
            },
            domProps: {
              innerHTML: htmlStr
            }
          });
        },
        duration: 20
      });
    },
    remove(row, index, even) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否要取消下发该条指令？</p>",
        onOk: () => {
          var that = this;
          this.isSpinShow = true;
          $.ajax({
            url: "/api/removeDownMessage",
            contentType: "application/json",
            type: "post",
            dataType: "json",
            data: JSON.stringify({
              deviceId: that.deviceId,
              primaryId: row.primaryId
            }),
            success: function(data) {
              console.log(data);
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }

              that.$Notice.success({
                title: "提示",
                desc: "移除成功"
              });
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    commitRegiste() {
      let msg = "";
      try {
        msg = JSON.parse(this.currentProfile);
      } catch (err) {
        this.$Notice.info({
          title: "提示",
          desc: "JSON格式不符合规范请检查后重新校验"
        });
        return;
      }

      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/registProfile",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          profile: that.currentProfile
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.$Notice.success({
            title: "提示",
            desc: "移除成功"
          });
          that.showPage();
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url: "/api/getDownQueue",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          deviceId: that.deviceId
        }),
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          //   console.log(data.body.body.queue);
          if (data.body) {
            that.showData = data.body.body.queue;
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    }
  }
};
</script>
<style>
.ivu-tree {
  left: 30%;
}

.ivu-tree ul {
  /* list-style: none; */
  margin: 5px;
  padding: 0;
  font-size: 16px;
}
.ivu-notice-notice {
  width: 500px;
  right: 160px;
}
.query_condition {
  border: 1px solid #c0c0c0;
  padding: 2px;
  margin: 2px;
  border-radius: 5%;
}
.check_grop div {
  margin-bottom: 1px;
}
</style>